import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { ReactElement, useEffect } from 'react';

import CompanyEvent from 'components/Event';

import { API_ROUTES } from 'lib/api-routes';
import { ONBOARDING_FLOW_STATE } from 'lib/consts/flowState';
import { withAuth } from 'lib/hocs/withAuth';
import { TouchpointType } from 'lib/models/touchpoint';
import { useAuth } from 'lib/providers/AuthProvider';
import { apiInstance } from 'lib/utils/axios';

import styles from './Create.module.scss';

const Create = (): ReactElement => {
  const router = useRouter();
  const { type, onboarding } = router.query;

  const { updateUserApiResponse, isManager, isRecruiter } = useAuth();

  useEffect(() => {
    if (onboarding) {
      const flow_state = ONBOARDING_FLOW_STATE.COMPLETE;
      if (isManager) {
        const manager = { flow_state };
        apiInstance
          .patch(API_ROUTES.MANAGER_USER, {
            manager,
          })
          .then((res) => updateUserApiResponse(res.data));
      } else if (isRecruiter) {
        const recruiter = { flow_state };
        apiInstance
          .patch(API_ROUTES.RECRUITER_SIGNUP, {
            recruiter,
          })
          .then((res) => updateUserApiResponse(res.data));
      }
    }
  }, [onboarding, isManager, isRecruiter]);

  return (
    <>
      <Head>
        <title>Create new | Huzzle</title>
        <meta name="description" content="Huzzle" />
      </Head>
      <section className={styles.Create} data-testid="Create">
        {type === TouchpointType.Event ? <CompanyEvent /> : null}
      </section>
    </>
  );
};
export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'opportunity.posting',
      ])),
    },
  };
}

const CreateWrapper = withAuth(Create);

export default CreateWrapper;
